import { render, staticRenderFns } from "./PazientiEdit.vue?vue&type=template&id=00a753d1"
import script from "./PazientiEdit.vue?vue&type=script&lang=js"
export * from "./PazientiEdit.vue?vue&type=script&lang=js"
import style0 from "./PazientiEdit.vue?vue&type=style&index=0&id=00a753d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports